import React from 'react'
import styles from './Home.module.css'
import {
  Svg3PointsMore,
  SvgLogoMetropole,
} from '../../components/svg/SvgComponents'

import DropdownProfile from '../../components/DropdownProfile/DropdownProfile'
import HeaderV2 from '../../components/HeaderV2/HeaderV2'

function Home() {
  return (
    <div className={styles.page}>
      <HeaderV2 />
      <div className={styles.wrap}>
        <div className={styles.filter_subnav}>
          <div className={styles.filter_subnav__inner}>
            <div className={styles.filter_categories}>
              <ul className={styles.ul_filter}>
                <li className={styles.category__sets}>Aujourd'hui</li>
                <li className={styles.category__sets}>Hier</li>
                <li className={styles.category__sets}>Cette semaine</li>
                <li className={styles.category__sets}>Ce mois-ci</li>
              </ul>
            </div>
          </div>
        </div>

        <div className={styles.wrap_inner}>
          <div className={styles.content}>
            <div className={styles.main}>
              <div className={styles.element__grid}>
                {/* element */}
                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>

                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>

                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>

                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>

                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>

                <div className={styles.element}>
                  <div className={styles.preview__form}></div>
                </div>
                {/* element */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
